import { Component } from "react";
import PropTypes from "prop-types";
import global from "global";
import styles from "./index.css";

class IntersectionObserver extends Component {
  constructor(props) {
    super(props);
  }

  unobserve = () => {
    this.observer.unobserve(this.target);
  };

  observe = () => {
    const { root, rootMargin, threshold, onIntersection, watchOptions } =
      this.props;

    const options = {
      root,
      rootMargin,
      threshold
    };

    this.observer = new global.IntersectionObserver(
      (entries, observer) =>
        onIntersection(
          entries,
          observer,
          watchOptions,
          this.unobserve.bind(this)
        ),
      options
    );

    this.observer.observe(this.target);
  };

  componentDidMount() {
    this.observe();
  }

  componentDidUpdate(prevProps) {
    const propsChanged = Object.keys(this.props.watchOptions).find(
      opt => this.props.watchOptions[opt] !== prevProps.watchOptions[opt]
    );

    if (propsChanged) {
      this.unobserve();
      this.observe();
    }
  }

  componentWillUnmount() {
    this.unobserve();
  }

  render() {
    return (
      <div ref={target => (this.target = target)} className={styles.observer}>
        {this.props.children}
      </div>
    );
  }
}

IntersectionObserver.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  onIntersection: PropTypes.func.isRequired,
  root: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(HTMLElement)
  ]),
  rootMargin: PropTypes.string,
  threshold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)
  ]),
  watchOptions: PropTypes.object.isRequired
};

export default IntersectionObserver;
